module.exports = __webpack_public_path__ + "b3764d39a0345c3176446b2185d68fc0.pdf";